import { createStore, select, withProps } from '@ngneat/elf';
import {
  selectAllEntities,
  setEntities,
  withEntities,
} from '@ngneat/elf-entities';
import { RateModel } from '../model';
import { filter, map, withLatestFrom } from 'rxjs/operators';

const store = createStore(
  { name: 'rate' },
  withEntities<RateModel, 'rateId'>({ idKey: 'rateId' }),
  withProps<{ loading: boolean }>({ loading: false })
);

const rates$ = store.pipe(selectAllEntities());

const rateIsLoading$ = store.pipe(select((state) => state.loading));

const rateLoaded$ = rates$.pipe(
  withLatestFrom(rateIsLoading$),
  filter(([rates, loading]) => rates.length > 0 && !loading),
  map(([rates]) => rates)
);

const setLoading = (loading: boolean) =>
  store.update((state) => ({ ...state, loading }));

const setRates = (rates: RateModel[]) => store.update(setEntities(rates));

export const RateRepository = {
  store,
  setRates,
  setLoading,
  rateLoaded$,
  rateIsLoading$,
};
